var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-tabs__active-bar-custom",class:`is-${ _vm.rootTabs.tabPosition }`,style:(_vm.barStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }